export const dispatcher = (store) => (next) => (action) => {
    const event = new CustomEvent(`DONKEY.${action.type}`, { payload: action.payload });

    document.dispatchEvent(event);

    next(action);
};
